// =============================================================================
// src/data/analytics-live-config.ts — Configuração do Analytics live (Hasura).
//
// Mesmo endpoint Hasura do Sentinel (VITE_HASURA_URL — o source social_listening
// só muda os root fields, prefixo sl_). O client_id pode diferir: o cliente VIVO
// do social_listening (config.client slug amazonas-2026) não é o piloto do
// monitoring.*, então VITE_ANALYTICS_CLIENT_ID tem cadeia de fallback para o
// VITE_SENTINEL_CLIENT_ID e por fim o piloto (dev não quebra sem env).
// =============================================================================

export interface AnalyticsLiveEnv {
  readonly VITE_HASURA_URL?: string;
  readonly VITE_ANALYTICS_CLIENT_ID?: string;
  readonly VITE_SENTINEL_CLIENT_ID?: string;
}

export interface AnalyticsLiveConfig {
  readonly enabled: boolean;
  readonly graphqlEndpoint: string;
  readonly clientId: string;
}

const PILOT_CLIENT_ID = 'a0000000-0000-4000-8000-000000000001';

/**
 * Resolve a config do Analytics live a partir do import.meta.env.
 *
 * @example const config = resolveAnalyticsLiveConfig(import.meta.env);
 */
export function resolveAnalyticsLiveConfig(env: AnalyticsLiveEnv): AnalyticsLiveConfig {
  const graphqlEndpoint = (env.VITE_HASURA_URL ?? '').trim();
  const clientId = (env.VITE_ANALYTICS_CLIENT_ID ?? env.VITE_SENTINEL_CLIENT_ID ?? PILOT_CLIENT_ID).trim();
  return { enabled: graphqlEndpoint.length > 0, graphqlEndpoint, clientId };
}
